export { default as ExpandableTransition } from './ExpandableTransition.vue';
